export default __webpack_public_path__ + "static/media/Mimi_9781408342725.289c670e.jpg";